import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Retry = ({ className, color }) => (
  <svg
    className={ className }
    fill={ color }
    { ...iconCommonProps }
    viewBox='0 0 24 24'
  >
    <g>
      <path
        clipRule='evenodd'
        d='M15.323,4.445c-1.825-0.804-3.889-0.931-5.807-0.323 c-3.644,1.147-6.01,4.604-5.764,8.41l-2.486,0.163C0.944,7.739,4.029,3.238,8.765,1.742c2.776-0.875,5.781-0.572,8.334,0.807 L19.485,0l0.636,7.074l-7.493,0.25L15.323,4.445z M15.231,22.257c-1.05,0.329-2.141,0.496-3.224,0.496 c-1.765,0-3.517-0.456-5.099-1.306L4.517,24l-0.635-7.074l7.489-0.252l-2.693,2.882c1.822,0.801,3.886,0.927,5.804,0.322 c3.643-1.15,6.012-4.611,5.763-8.409l2.487-0.163C23.059,16.255,19.974,20.758,15.231,22.257z'
        fillRule='evenodd'
      />
    </g>
  </svg>
);

Retry.propTypes = { ...iconPropTypes };

Retry.defaultProps = { ...iconDefaultProps };

export default Retry;